<script setup lang="ts">
import { breakpointsTailwind, useBreakpoints } from "@vueuse/core";
const breakpoints = useBreakpoints(breakpointsTailwind);
const smallerThanMd = breakpoints.smallerOrEqual("md");
type InfoTypeProps = {
    secondary: boolean;
    third: boolean;
};

defineProps<InfoTypeProps>();
</script>

<template>
    <TranslateNamespace path=".section">
        <VFlex
            :flex-direction="smallerThanMd ? 'column' : 'row'"
            :align-items="smallerThanMd ? 'flex-start' : 'center'"
            row-gap="1rem"
            column-gap="1rem"
            class="px-6 py-5 title-section"
            :class="[
                $props.secondary && 'secondary-title',
                $props.third && 'third-title',
            ]">
            <div class="title-text">
                <div class="is-size-1 is-weight-700 is-uppercase">
                    <span>
                        <slot name="titleP1"></slot>
                    </span>
                    <span class="has-text-primary">
                        <slot name="titleP2"></slot>
                    </span>
                </div>
            </div>
            <div class="is-flex-grow-1 title-divider">
                <hr />
                <hr />
            </div>
        </VFlex>
    </TranslateNamespace>
</template>

<style scoped lang="scss">
@use "sass:color";

.w-100 {
    width: 100%;
}

.title-section {
    .title-text {
        line-height: 1.2;
        font-family: "Bebas Neue";
        color: $dark;
        width: fit-content;
    }

    .title-divider {
        hr {
            &:nth-child(1) {
                background-color: $dark;
                margin-bottom: 5px;
                margin-top: 0;
            }

            &:nth-child(2) {
                background-color: $primary;
                margin-top: 5px;
                margin-bottom: 0;
            }
        }
    }
}

.secondary-title {
    .title-text {
        color: #fff;
    }

    .title-divider {
        hr {
            &:nth-child(1) {
                background-color: #fff;
                margin-bottom: 5px;
                margin-top: 0;
            }
        }
    }
}

.third-title {
    padding: 1.5rem 0 !important;
}

@media (max-width: 600px) {
    .title-text {
        > div {
            font-size: 2.5rem !important;
        }
    }
}
</style>
